import TripItemRailTicketsQuestionModule from './trip-item-rail-tickets-question/trip-item-rail-tickets-question-module';

import TripItemCancellation from './trip-item-cancellation-component';
import TripItemCancellationService from './trip-item-cancellation-service';

import './trip-item-cancellation.scss';

const MODULE_NAME = 'app.trip.item-cancellation';
const module = angular.module(MODULE_NAME, [
        TripItemRailTicketsQuestionModule,
    ])
    .directive(TripItemCancellation.DIRECTIVE_NAME, TripItemCancellation)
    .service('tripItemCancellationService', TripItemCancellationService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-cancellation/trip-item-cancellation-module.js